import { Schema } from "@comparaonline/products-schema";
import { useAppContext } from "../../../../../lib/appContext";
import { getCaptureCta, getFormCta, hasForm } from "../../../../../models/product";

export const useCTAProps = () => {
  const appContext = useAppContext();
  const getCta = hasForm(appContext) ? getFormCta : getCaptureCta;
  return (productData: Schema.ProductListProduct) => {
    const { text, url, disabled } = getCta(appContext, productData);
    return { buttonText: text, href: url, disabled, rel: "nofollow" };
  };
};
